module.exports = __webpack_public_path__ + "assets/img/touxiang.3f29696c.png";